import { render, staticRenderFns } from "./SelectEventsModal.vue?vue&type=template&id=37c6b8a4&scoped=true"
import script from "./SelectEventsModal.vue?vue&type=script&lang=js"
export * from "./SelectEventsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectEventsModal.vue?vue&type=style&index=0&id=37c6b8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6b8a4",
  null
  
)

export default component.exports